<!-- Start Nav Structure -->
<button class="cn-button" id="cn-button">
    <i class="ti-menu"></i>
</button>
<div class="cn-wrapper " id="cn-wrapper">
    <ul>
        <li>
            <a [routerLink]="['../matrizriesgo']" data-toggle="tooltip" data-placement="top" data-trigger="hover"
                title="Buscar Matriz">
                <span class="icofont icofont-document-search "></span>
            </a>
        </li>
        <li>
            <a [routerLink]="[]" (click)="AgregarMatriz()" data-toggle="tooltip" data-placement="top" data-trigger="hover"
                title="Crear Matriz">
                <span class="fa fa-cogs"></span>
            </a>
        </li>
        <li>
            <a [routerLink]="['../evaluacionriesgo']" data-toggle="tooltip" data-placement="top" data-trigger="hover"
                title="Buscar Evaluación">
                <span class="icofont icofont-checked"></span></a>
        </li>
        <li>
            <a [routerLink]="['../ejecutarevaluacion']" data-toggle="tooltip" data-placement="top" data-trigger="hover"
                title="Ejecutar Evaluación">
                <span class="fa fa-play"></span></a>
        </li>
        <li>
            <a [routerLink]="['../agregarevaluacion']" data-toggle="tooltip" data-placement="top" data-trigger="hover" title="Crear Evaluación">
                <span class="icofont icofont-match-review"></span>
            </a>
        </li>
    </ul>
</div>
<div id="cn-overlay" class="cn-overlay"></div>
<!-- End Nav Structure -->